import { render, staticRenderFns } from "./ChatterTopBar.vue?vue&type=template&id=08f3ad02&scoped=true"
import script from "./ChatterTopBar.vue?vue&type=script&lang=js"
export * from "./ChatterTopBar.vue?vue&type=script&lang=js"
import style0 from "./ChatterTopBar.vue?vue&type=style&index=0&id=08f3ad02&prod&lang=css"
import style1 from "./ChatterTopBar.vue?vue&type=style&index=1&id=08f3ad02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3ad02",
  null
  
)

export default component.exports